// Shared weekday helpers for AI / PD sessions.
// A session runs from startDate -> endDate. When it has a non-empty daySchedules
// array (batch-style weekday scheduling), only the dates whose weekday is in the
// schedule count as session days. Legacy sessions (no daySchedules) fall back to
// every calendar day in the range.

export const WEEK_DAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

// Sunday = 0 ... Saturday = 6 (matches Date.getUTCDay()).
export const DAY_NAME_TO_INDEX = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

export const DAY_SHORT = {
  Monday: 'Mon',
  Tuesday: 'Tue',
  Wednesday: 'Wed',
  Thursday: 'Thu',
  Friday: 'Fri',
  Saturday: 'Sat',
  Sunday: 'Sun',
};

// Returns an array of "YYYY-MM-DD" strings (inclusive) between start and end.
// If daySchedules is non-empty, only scheduled weekdays are kept.
export const getScheduledDays = (startDate, endDate, daySchedules = []) => {
  if (!startDate) return [];

  const start = new Date(startDate);
  const end = new Date(endDate || startDate);
  const startUTC = Date.UTC(
    start.getFullYear(),
    start.getMonth(),
    start.getDate()
  );
  const endUTC = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
  if (Number.isNaN(startUTC) || Number.isNaN(endUTC) || endUTC < startUTC) {
    return [];
  }

  const scheduledIndexes = new Set(
    (daySchedules || [])
      .map((slot) => DAY_NAME_TO_INDEX[slot?.day])
      .filter((index) => index !== undefined)
  );

  const days = [];
  for (let t = startUTC; t <= endUTC; t += 86400000) {
    const current = new Date(t);
    if (
      scheduledIndexes.size === 0 ||
      scheduledIndexes.has(current.getUTCDay())
    ) {
      days.push(current.toISOString().slice(0, 10));
    }
  }
  return days;
};

// "Mon 10:00–12:00 · Wed 14:00–16:00"
export const formatDaySchedules = (daySchedules = []) =>
  (daySchedules || [])
    .map((slot) => {
      const label = DAY_SHORT[slot.day] || slot.day;
      const time =
        slot.startTime || slot.endTime
          ? ` ${slot.startTime || ''}${slot.endTime ? `–${slot.endTime}` : ''}`
          : '';
      return `${label}${time}`;
    })
    .join(' · ');
